export default "__VITE_ASSET__CYTpJR36__"